import { Box, styled } from '@mui/material';
import { CandidateMatchCardSkeleton } from 'features/Connect/components/LoadingSkeletons/MatchCardLoadingSkeleton';
import { CandidateDashboardViews } from '../../../../CandidatePortal/CandidateDashboardViews/CandidateDashboardViews';
import { ViewState } from '../../../../CandidatePortal/CandidateDashboardViews/utils/constants';
import { CandidateMatchArchiveCard } from 'features/Connect/components/MatchArchiveCard/CandidateMatchArchiveCard';
import { DashboardViewStates } from './utils/constants';
import { ConnectCandidateMatchArchiveDashboardDataTestIds } from 'data-testids/CandidatePortalDataTestIds';
import { CandidateMatchArchiveDashboardBodyProps } from './utils/types';

export const CandidateMatchArchiveDashboardBody: React.FC<
  CandidateMatchArchiveDashboardBodyProps
> = ({ viewState, filteredArchivedMatches }) => {
  const renderContent = () => {
    switch (viewState) {
      case DashboardViewStates.NOT_OPEN_TO_MATCHES:
        return (
          <CandidateDashboardViews
            viewState={ViewState.NOT_OPEN_TO_MATCHES}
            setShouldShowSuccessToastMessage={() => {}}
          />
        );

      case DashboardViewStates.LOADING:
        return (
          <MatchArchiveDashboardBodyContainer>
            <CandidateMatchCardSkeleton />
          </MatchArchiveDashboardBodyContainer>
        );

      case DashboardViewStates.NO_ARCHIVED_MATCHES:
        return (
          <MatchArchiveDashboardBodyContainer>
            <CandidateDashboardViews viewState={ViewState.NO_ARCHIVED_MATCHES} />
          </MatchArchiveDashboardBodyContainer>
        );

      case DashboardViewStates.HAS_ARCHIVED_MATCHES:
        return (
          <MatchArchiveDashboardBodyContainer>
            <CandidateMatchArchiveCardList>
              {filteredArchivedMatches.map((archivedMatch) => (
                <CandidateMatchArchiveCard key={archivedMatch.id} archivedMatch={archivedMatch} />
              ))}
            </CandidateMatchArchiveCardList>
          </MatchArchiveDashboardBodyContainer>
        );

      default:
        return null;
    }
  };

  return (
    <MatchArchiveDashboardBodyRenderContainer
      data-testid={ConnectCandidateMatchArchiveDashboardDataTestIds.DASHBOARD_BODY}
    >
      {renderContent()}
    </MatchArchiveDashboardBodyRenderContainer>
  );
};

const MatchArchiveDashboardBodyRenderContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
}));

const MatchArchiveDashboardBodyContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(0, 2),
  },
}));

const CandidateMatchArchiveCardList = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  gap: theme.spacing(4),
}));
